exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".json-editor[data-v-b286fc80]{\n  height: 100%;\n  margin-bottom: 10px;\n}\n.json-editor[data-v-b286fc80] .CodeMirror {\n  font-size: 14px;\n  overflow-y:auto;\n  font-weight:normal\n}\n.json-editor[data-v-b286fc80] .CodeMirror-scroll{\n}\n.json-editor[data-v-b286fc80] .cm-s-rubyblue span.cm-string {\n  color: #F08047;\n}\n", ""]);

// exports
